export default "__VITE_ASSET__4483f0b9__"